import type { Translations } from '../../../types'

const shopProductTypeMessages: Translations = {
  "shop.productType.generic.label": "Generico",
  "shop.productType.generic.description": "Prodotto generico",
  "shop.productType.nonePlugin": "nessuno",
  "shop.productType.nonePluginName": "Nessun plugin",
  "shop.productType.descriptionFallback": "Prodotto {{label}}",
}

export default shopProductTypeMessages
